// extracted by mini-css-extract-plugin
module.exports = {"root":"ExpandedContainer_root__1BM1a"};